//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {VueShowdown} from 'vue-showdown'
import {updateUrl} from '../utils'
import AppModal from "@/components/AppModal";

export default {
  name: 'Tiles',

  components: {
    AppModal,
    VueShowdown
  },

  props: {
    scopes: {
      type: Object,
      default: () => ({})
    },
    blocks: {
      type: Array,
      default: () => ([])
    }
  },
  inject: ['cmsBaseUrl', 'httpClient'],

  computed: {
    computedBlocks() {
      return this.localBlocks.map(item => {
        item.list = item.list.reduce((acc, el) => {
          // если есть список ролей и этих ролей нет в разрешенных - то рисовать замок
          if (el.roles && el.roles.length && el.roles.split(',').every(role => !Object.keys(this.scopes).includes(role))) {
            el.blocked = true
          }
          if (el.isActive) {
            acc.push(el)
          }
          return acc
        }, [])
        return item
      })
    }
  },

  data: () => ({
    smallBlocks: [],
    modalAbout: false,
    info: '',
    modalTitle: '',
    localBlocks: []
  }),

  async created() {
    this.getSmallBlocks()
  },

  watch: {
    '$i18n.locale'() {
      this.getSmallBlocks()
    },
    scopes() {
      this.localBlocks = JSON.parse(JSON.stringify(this.blocks))
    },
    blocks() {
      this.localBlocks = JSON.parse(JSON.stringify(this.blocks))
    },
  },

  methods: {
    async getSmallBlocks() {
      const {data} = await this.httpClient.get(`${this.cmsBaseUrl}/moex-services`, {
        params: {
          locale: this.$i18n.locale
        }
      })
      if (data.data) {
        this.smallBlocks = data.data
      }
    },
    showAbout(data) {
      this.info = data.info || '';
      this.modalTitle = `${ this.$t('tilesAbout') }: ${data.title}`;
      this.modalAbout = true;
    },
    goToApp(item) {
      if (!item.blocked) {
        this.$emit('change-route', item.code)
        window.singleSpaNavigate(item.url)
        updateUrl(this.$i18n)
      }
    }
  }
}
